import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import Iconify from '../../../../Iconify';
import useRealNode from '../../../../../hooks/useRealNode';
import { ModalPanel, Bar, CloseButton, Content } from './modal-styled';
import { publish, subscribe, unsubscribe } from '../../../../../utils/events';

const EVENT_NAME = 'PAYMENTS:SHOW_MODAL_CONFIRM_DELETE_CARD';

// Flag global para rastrear si el modal ya está siendo mostrado
let isModalOpen = false;

export const showModalConfirmDeleteCard = (data) => {
  return new Promise((resolve) => {
    publish(EVENT_NAME, {
      data,
      resolve,
    })
  })
};

export const ModalConfirmDeleteCard = () => {
  const node = useRealNode('modal-node-portal');
  const [isOpen, setIsOpen] = useState(false);
  const [data, setData] = useState(null);
  const isThisInstanceOpenRef = React.useRef(false);
  const resolveRef = React.useRef(null);

  useEffect(() => {
    const listener = event => {
      // Solo procesar el evento si el modal no está abierto globalmente
      if (isModalOpen) {
        return;
      }

      // Marcar el modal como abierto antes de procesarlo
      isModalOpen = true;
      isThisInstanceOpenRef.current = true;
      setData(event.detail.data);
      resolveRef.current = event.detail.resolve;
      setIsOpen(true);
    };

    subscribe(EVENT_NAME, listener);

    return () => {
      unsubscribe(EVENT_NAME, listener);
      // Si este componente se desmonta y tenía el modal abierto, resetear el flag
      if (isThisInstanceOpenRef.current) {
        isModalOpen = false;
        isThisInstanceOpenRef.current = false;
      }
    };
  }, []);

  const handleClose = () => {
    setIsOpen(false);
    isThisInstanceOpenRef.current = false;
    // Resetear el flag cuando se cierra el modal
    isModalOpen = false;
    resolveRef.current(false);
  };

  const stopPropagation = event => {
    event.stopPropagation();
    event.preventDefault();
  };

  const handleConfirm = () => {
    resolveRef.current(true);
    setIsOpen(false);
    isThisInstanceOpenRef.current = false;
    // Resetear el flag cuando se cierra el modal
    isModalOpen = false;
  };

  if (!isOpen || !node) return null;

  return ReactDOM.createPortal(
    <ModalPanel tabIndex="1">
      <Content style={{ maxWidth: 500, minHeight: 200 }} onClick={stopPropagation}>
        <Bar type="success">
          <span>¿Estás seguro de que quieres eliminar esta tarjeta?</span>
          <CloseButton onClick={handleClose}>
            <Iconify icon="ic:baseline-close" />
          </CloseButton>
        </Bar>
        <Text>Eliminar tarjeta con terminación: {data?.card?.card_number}</Text>
        <ButtonsDelete>
          <ButtonConfirm onMouseDown={handleConfirm} className='guardar-picks btn-rojo'>Eliminar</ButtonConfirm>
          <ButtonCancel onMouseDown={handleClose} className='guardar-picks'>Cancelar</ButtonCancel>
        </ButtonsDelete>
      </Content>
    </ModalPanel>,
    node
  );
};

const Text = styled.div`
  color: #ffffff;
  font-size: 15px;
  text-align: center;
  margin: 0;
  line-height: 1.5;
  text-align: center;
  margin-top: 2em;
`

export const ButtonsDelete = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 500px;
  margin: auto;
  gap: 2em;
`

export const ButtonBase = styled.button`
  border: 0;
  outline: 0;
  color: #FFF;
  font-size: 1.2em;
  font-weight: bold;
  padding: 0.5em 2.5em;
  border-radius: 1em;
  transition: transform 200ms ease;
  will-change: transform;
  width: 150px;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  &:hover {
    opacity: 0.9;
    transform: scale(1.02);
  }
`

export const ButtonCancel = styled(ButtonBase)`
  background-color: #88ba44;
`

export const ButtonConfirm = styled(ButtonBase)`
  background-color: #ff0000;
`

const SuccessContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem 1.5rem;
  gap: 1rem;
  min-height: 150px;
`;

const SuccessIcon = styled.div`
  color: #78bc28;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 3rem;
`;

const SuccessMessage = styled.p`
  color: #ffffff;
  font-size: 1.3rem;
  text-align: center;
  margin: 0;
  line-height: 1.5;
`;

const BalanceMessage = styled.p`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  color: #78bc28;
  font-size: 1.7rem;
`;

const TransactionIdMessage = styled.p`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  color: #656565;
  margin-top: 2em;
`;